import { render, staticRenderFns } from "./ChatGptWidget.vue?vue&type=template&id=2b18a188&scoped=true&"
import script from "./ChatGptWidget.vue?vue&type=script&lang=js&"
export * from "./ChatGptWidget.vue?vue&type=script&lang=js&"
import style0 from "./ChatGptWidget.vue?vue&type=style&index=0&id=2b18a188&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b18a188",
  null
  
)

export default component.exports